module.exports = __webpack_public_path__ + "static/rhs_blue@2x-81beac27ffea98629578816172cbd825.png";